import * as React from 'react';
import { useIntl } from 'react-intl';
import { LocaleContext } from '../../../contexts/LocaleContext';
import { useHideStoresLogo } from '../../../hooks/useHideStoresLogo';
import css from './SiteFooter.module.scss';
import { buildSiteUrl } from 'src/utils/request-url';

interface Props {
  merchantPublicId?: string | null;
  onFreePlan?: boolean;
}

const SiteFooter: React.FC<Props> = ({ merchantPublicId, onFreePlan }) => {
  const intl = useIntl();
  const localeCtx = React.useContext(LocaleContext);
  const intlPref = 'components.common.layouts.merchantGlobalFooter.siteFooter.';

  const { isHiddenStoresLogo } = useHideStoresLogo();

  return (
    <div className={css.SiteFooter}>
      <div className={css.SiteFooter__Inner}>
        {!isHiddenStoresLogo &&
          (onFreePlan ? (
            <a
              href="https://stores.fun/reserve"
              className={css.SiteFooter__CopyrightLink}
            >
              STORES, Inc.
            </a>
          ) : (
            <span className={css.SiteFooter__Copyright}>STORES, Inc.</span>
          ))}
        <div className={css.SiteFooter__Links}>
          <a
            href="https://stores.fun/legal/reserve-user-terms"
            className={css.SiteFooter__Link}
          >
            {intl.formatMessage({ id: intlPref + 'links.user_terms' })}
          </a>
          <a
            href="https://stores.fun/legal/reserve-user-privacy"
            className={css.SiteFooter__Link}
          >
            {intl.formatMessage({ id: intlPref + 'links.policy' })}
          </a>
          {merchantPublicId && (
            <a
              href={buildSiteUrl(`/legal_notice`)}
              className={css.SiteFooter__Link}
            >
              {intl.formatMessage({ id: intlPref + 'links.sct' })}
            </a>
          )}
        </div>
        <div className={css.SiteFooter__Language}>
          <span>{intl.formatMessage({ id: intlPref + 'language' })}: </span>
          <select
            className={css.SiteFooter__LanguageSelect}
            onChange={(e) => {
              localeCtx.changeLocale(e.target.value);
            }}
            value={localeCtx.currentLocale}
          >
            <option value="ja">日本語</option>
            <option value="en">English</option>
            <option value="ko">한국어</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default SiteFooter;
